// extracted by mini-css-extract-plugin
export var bodyRow = "_gu-d";
export var cardColumns = "_gu-e";
export var ellipsesOverflow = "_gu-2";
export var flatBottomCorners = "_gu-3";
export var flatTopCorners = "_gu-4";
export var headerActionsDropdown = "_gu-f";
export var headerBottomRow = "_gu-c";
export var headerTopRow = "_gu-b";
export var orderDetailsWrapper = "_gu-0";
export var orderInfoContainer = "_gu-1";
export var productDetails = "_gu-9";
export var productImage = "_gu-5";
export var responsiveTable = "_gu-8";
export var shipmentContainer = "_gu-a";
export var tableBottomLeft = "_gu-6";
export var tableBottomRight = "_gu-7";
export var trackingLink = "_gu-g";